import React, { createContext, useContext, useState } from "react";

export const ResumeBuilderContext = createContext();

export const useResumeBuilder = () => useContext(ResumeBuilderContext);

export const ResumeBuilderProvider = ({ children }) => {
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);
  const [isPreviewVisible, setIsPreviewVisible] = useState(true);
  const [resumeName, setResumeName] = useState("Untitled Resume");

  const triggerDemoLoad = () =>
    window.dispatchEvent(new Event("load-demo-data"));
  const triggerCustomSection = () =>
    window.dispatchEvent(new Event("add-custom-section"));
  const triggerDownload = () => window.dispatchEvent(new Event("download-pdf"));
  const triggerSaveAndUse = () =>
    window.dispatchEvent(new Event("save-and-use"));
  const triggerNewResume = () =>
    window.dispatchEvent(new Event("create-new-resume"));

  const value = {
    isConfigModalOpen,
    setIsConfigModalOpen,
    isPreviewVisible,
    setIsPreviewVisible,
    resumeName,
    setResumeName,
    triggerDemoLoad,
    triggerCustomSection,
    triggerDownload,
    triggerSaveAndUse,
    triggerNewResume,
  };

  return (
    <ResumeBuilderContext.Provider value={value}>
      {children}
    </ResumeBuilderContext.Provider>
  );
};
